import React, { PureComponent, Fragment } from 'react';
import { bool, func, node, number, oneOfType, string } from 'prop-types';
import { List, ListItemText, Box } from '@mui/material';
import { Divider } from '@mui/material';
import { SimpleText } from '../../util/IntlMessages';
import ShowMore from '../ShowMore';

class LoadableList extends PureComponent {
  static propTypes = {
    children: node,
    dataLength: number,
    emptyText: oneOfType([node, string]),
    hasMore: bool,
    loading: bool,
    loadMore: func,
  };

  static defaultProps = {
    dataLength: 0,
    emptyText: <SimpleText id="messages.emptyList" />,
    hasMore: false,
    loading: false,
    loadMore: () => {},
  };

  render() {
    if (!this.props.dataLength && !this.props.loading) {
      return (
        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          <List sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <ListItemText primary={this.props.emptyText} />
          </List>
        </Box>
      );
    }

    return (
      <List sx={{ pt: 0 }}>
        {this.props.children}
        {this.props.hasMore && (
          <Fragment>
            <ShowMore onLoadMore={this.props.loadMore} />
            <Divider light />
          </Fragment>
        )}
      </List>
    );
  }
}

export default LoadableList;
